module.exports = __webpack_public_path__ + "s7.no2.a10b89aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s7.no2.jpg
// module id = LmHN
// module chunks = 0